import { RecordTypeChangesReport } from 'interfaces/facility';

/**
 * @description Get the CSS class for the view changes cell based on record type
 *
 * @SADtrace SAD-003-6.1
 *
 * @History
 * 04-18-2025 aleksandar dukleski: DLA-1364 added function headers
 * 11-05-2025 aleksandar dukleski: DLA-1428 added history tag to function headers
 *
 * @param {RecordTypeChangesReport} row - The row to get the class for
 *
 * @returns {string} The CSS class for the view changes cell ('added', 'deleted', or '')
 */
export const getViewChangesCellClass = (row: RecordTypeChangesReport) => {
  switch (row.recordType) {
    case 'ADDED':
      return 'added';
    case 'DELETED':
      return 'deleted';
    case 'UPDATED':
      return '';
  }
};
